($ => {

	'use strict';

	const header = document.querySelector('.header')

	function init() {

		countNewsPosts()

		if(window.innerWidth < 992) {
			headerMobile()
		} else {
			headerScroll()
			manageSubmenus()
		}

		toggleSearch()
        
	}

	function countNewsPosts() {

		const items = Array('news', 'events')

		items.forEach((item) => {
			
			if(sessionStorage.getItem(item) == null) {

				jQuery.post(
					MyAjax.ajaxurl,
					{
						'action': 'count_new_posts',
						'cat': item,
					},
					function(response){
		
						var json = JSON.parse(response);
		
						if(json.success) {
	
							sessionStorage.setItem(item, json.data)

							addBubble(item, json.data)
		
						}
					}
				)

			} else {

				addBubble(item, sessionStorage.getItem(item))

			}

			
		})

		function addBubble(item, count) {

			$('.nav-' + item).addClass('hasBubble')
			$('.nav-' + item).append('<span class="countBubble">' + count + '</span>')

		}
	}

	function headerScroll() {

		const headerPrimary = header.querySelector('.header__primary')

		const delta = document.querySelector('.pageHeader--simple') ? 0 : 100

		const myInterval = setInterval(() => {

			if( window.scrollY > delta ) {
				headerPrimary.classList.add('scrolled')
			} else {
				headerPrimary.classList.remove('scrolled')
			}

		}, 10)

	}

	function manageSubmenus() {

		const submenus = header.querySelectorAll('.header__submenu')

		const togglers = header.querySelectorAll('.header__primary__wrapper > ul > .menu-item-has-children')

		submenus.forEach((submenu) => {
			submenu.querySelector('.header__submenu__close').addEventListener('click', () => {
				setTimeout(() => {
					submenu.style.display = 'none'
				}, 450)
				submenu.classList.remove('active')
				fixedScroll(false)
			})
		})

		togglers.forEach((toggler) => {
			toggler.addEventListener('click', () => {
				submenus.forEach((submenu) => {
					if(submenu.dataset.id == toggler.id) {
						submenu.style.display = 'block'
						setTimeout(() => {
							submenu.classList.add('active')
						}, 50)
					} else {
						if(submenu.classList.contains('active')) {
							setTimeout(() => {
								submenu.style.display = 'none'
							}, 450)
						}
						submenu.classList.remove('active')
					}
				})
				fixedScroll(true)
			})
		})
	}

	function fixedScroll(fixed) {
		if(fixed) {
			body.dataset.y = window.scrollY
			setTimeout(() => {
				body.classList.add('fixed')
			}, 450)
		} else {
			body.classList.remove('fixed')
			window.scrollTo(0, body.dataset.y)
		}
	}

	function headerMobile() {

		const burger = header.querySelector('.header__mobile__burger')

		const mobile = header.querySelector('.header__mobile')

		const nav = header.querySelector('.header__nav')

		const search = header.querySelector('.header__primary__search--mobile')

		const togglers = header.querySelectorAll('.header__primary__wrapper > ul > .menu-item-has-children')

		const lang = header.querySelector('.header__secondary__lang')

		burger.addEventListener('click', () => {
			mobile.classList.toggle('active')
			search.classList.toggle('active')
			if(!nav.classList.contains('active')) {
				nav.style.display = 'flex'
				setTimeout(() => {
					nav.classList.add('active')
				}, 50)
				burger.ariaExpanded = true
				fixedScroll(true)
			} else {
				setTimeout(() => {
					nav.style.display = 'none'
				}, 450)
				nav.classList.remove('active')
				burger.ariaExpanded = false
				fixedScroll(false)
			}
		})

		togglers.forEach((toggler) => {
			toggler.querySelector('a').addEventListener('click', (e) => {
				e.preventDefault()
				toggleActive(toggler)
			})
		})

		lang.querySelector('.header__secondary__lang__toggler').addEventListener('click', () => {
			toggleActive(lang)
		})

		const toggleActive = el => {
			el.classList.toggle('active')
			if(el.classList.contains('active')) {
				el.scrollIntoView(true)
			}
		}

	}

	function toggleSearch() {
		const searchPopup = document.querySelector('.searchPopup')
		const searchTogglers = header.querySelectorAll('.header__primary__search')
		const searchPopupClose = searchPopup.querySelector('.searchPopup__close')

		searchTogglers.forEach((toggler) => {
			toggler.addEventListener('click', () => {
				searchPopup.style.display = 'block'
				setTimeout(() => {
					searchPopup.classList.add('active')
				}, 50)
				searchPopup.ariaHidden = false
				searchPopup.querySelector('.searchForm__input').focus()
				fixedScroll(true)
			})
		})

		searchPopupClose.addEventListener('click', () => {
			searchPopup.classList.remove('active')
			setTimeout(() => {
				searchPopup.style.display = 'none'
			}, 450)
			searchPopup.ariaHidden = true
			fixedScroll(false)
		})
	}

	$(document).ready(() => {
		init();
	});

})(jQuery);
